import { useState } from "react";
import Cookies from "js-cookie";
import CreateNoteUI from "../components/CreateNoteUI";

const URL = process.env.REACT_APP_API_URL;

export default function CreateNote() {
  const [text, setText] = useState("");
  let user = "";
  
  try {
    user = Cookies.get('user') ? JSON.parse(Cookies.get('user')) : null;
  } catch (error) {
    console.error("Error parsing user cookie:", error);
  }
  
  const username = user?.name || "usuario";

  const handleSend = () => {
    if (text.trim() === "") return;
    fetch(`${URL}/api/notes/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Empresa-Id": user?.empresa_id
      },
      body: JSON.stringify({
        empresa_id: user?.empresa_id,
        description: text,
        author: username,
      })
    });
    setText("");
  };

  return (
    <CreateNoteUI
      text={text}
      setText={setText}
      handleSend={handleSend}
    />
  );
}